import React, { useState } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import uniq from 'lodash/uniq'

import { listCashRegisters } from 'gql/query'
import { updateQuery, useMutation, useQuery } from 'components/graphql'
import { Text, Checkbox, Radio, TextEditor } from 'components/forms'
import { CashRegisters } from '../../statistics/pages/filterFragments'
import { listClientMessage, listUsers, createClientMessage as postMessageMutation } from '../gql'

import Button from 'components/Button'
import Divider from 'components/Divider'
import FilterCardRemote from 'components/FilterCard/FilterCardRemote'

const NewMessage = ({ appData, listQueryRef: { current }, onClose }) => {
	const [ t ] = useTranslation()
	const { data, queryField: field } = useQuery(listCashRegisters, {
		fetchPolicy: 'cache-first'
	})

	const [ createClientMessage ] = useMutation(postMessageMutation)
	const [clearVal, setClearVal] = useState(Math.random())
	const [state, setState] = useState({
		isForShop: true,
		sender: appData.name,
		subject: '',
		body: '',
		hasConfirm: false,
		recipientId: []
	})
	const [userId, setUserId] = useState([])
	const { isForShop, body, subject, hasConfirm, recipientId } = state

	const handleChangeTextEditor = (value) => {
		const formattedText = value.replace(/<[^>]*>?/gm, '')
		setState({ ...state, body: formattedText })
	}

	const onSend = () => {
		let recipientIdVar
		if(isForShop) {
			recipientIdVar = []
			const allCRs = data?.[field]
			if(!recipientId.length) {
				recipientIdVar = allCRs?.map?.(item => item.shopId)
			} else {
				recipientIdVar = recipientId?.map?.(item => {
					const { shopId } = allCRs?.find?.(i => i.id === item) || {}
					return shopId
				})
			}
			recipientIdVar = uniq(recipientIdVar)
		} else {
			recipientIdVar = userId
		}
		const createdAt = moment().utcOffset('Z', true)
		createClientMessage({
			variables: { required: { ...state, createdAt, recipientId: recipientIdVar } },
			update: updateQuery({ query: listClientMessage, variables: current?.variables }, (draft, { mutationResult = {}, readQuery, queryField }) => {
				const newLists = [...readQuery.items, mutationResult]
				draft[queryField].items = newLists
			}),
			optimisticResponse: {
				__typename: 'Mutation',
				cashAssist: {
					createClientMessage: {
						__typename: 'ClientMessage',
						id: -1,
						...state,
						createdAt
					},
					__typename: 'CA_Mutation'
				}
			}
		})
		onClose()
	}

	return (
		<>
			<Row>
				<Col xs={6}>
					<Radio
						onChange={() => {
							setState({ ...state, isForShop: true, recipientId: [] })
							setClearVal(Math.random())
						}}
						label={t('message_section.strings.branch')}
						value={isForShop}
						noForm
						checked={isForShop}
					/>
					<div style={!isForShop ? disabled : null}>
						<CashRegisters
							value={recipientId}
							onChange={value => setState({ ...state, recipientId: value })}
							height={160}
						/>
					</div>
				</Col>
				<Col xs={6}>
					<Radio
						onChange={() => {
							setState({ ...state, isForShop: false })
							setUserId([])
						}}
						label={t('message_section.strings.user')}
						value={isForShop}
						noForm
						checked={!isForShop}
					/>
					<div style={isForShop ? disabled : null}>
						<FilterCardRemote
							listQuery={listUsers}
							queryVariables={{ variables: { filter: { isActive: true } } }}
							value={!isForShop ? userId : []}
							onChange={value => setUserId(value)}
							height={160}
							label={t('message_section.strings.user')}
							allItemsLabel={t('message_section.strings.message_no_user')}
							clearValueFromParent={clearVal}
							labelStyles={custom}
							startAllInactive
							withSearch={true}
						/>
					</div>
				</Col>
			</Row>
			<Divider visible height={30}/>
			<Row>
				<Col xs>
					<Text noForm label={t('message_section.fields.subject')} onChange={(e) => setState({ ...state, subject: e.target.value })}/>
					<Checkbox noForm label={t('message_section.fields.has_confirm')} onChange={() => setState({ ...state, hasConfirm: !hasConfirm })}/>
				</Col>
			</Row>
			<Divider visible/>
			<Row>
				<Col xs={12}>
					<TextEditor
						style={{ maxWidth: '100%' }}
						height={250}
						noForm
						placeholder={t('message_section.strings.write_message')}
						label={t('message_section.caption')}
						onChange={handleChangeTextEditor}
					/>
				</Col>
			</Row>
			<Divider/>
			<Row>
				<Col xs={7}/>
				<Col xs>
					<Button status='cancelation' text={t('message_section.strings.cancel')} style={{ margin: '0' }} onClick={onClose}/>
					<Button status={(body.length > 1 && subject.length) ? 'primary' : 'inactive'} text={t('message_section.strings.send')} type='submit' onClick={onSend}/>
				</Col>
			</Row>
		</>
	)
}

export default NewMessage

const disabled = {
	pointerEvents: 'none',
	opacity: '0.5'
}

const custom = {
	boxShadow: '0px 0px 15px 4px rgba(194, 197, 199, 0.6)'
}
